import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

export const InventoryCategorySchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    name: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});

export const InventoryCategoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(InventoryCategorySchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type InventoryCategoryResponse = z.infer<typeof InventoryCategoryResponseSchema>;
export type InventoryCategoryData = z.infer<typeof InventoryCategorySchema>;
